import { render, staticRenderFns } from "./UserDialogThingAssignmentTabComponent.vue?vue&type=template&id=adfde794&scoped=true"
import script from "./UserDialogThingAssignmentTabComponent.js?vue&type=script&lang=js&external"
export * from "./UserDialogThingAssignmentTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./UserDialogThingAssignmentTabComponent.vue?vue&type=style&index=0&id=adfde794&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfde794",
  null
  
)

export default component.exports